module.exports = __webpack_public_path__ + "static/media/thumbs_up.bdfa942b.svg";